class ScrollGlobe {
	constructor() {
		this.block = document.querySelector('.block-scroll-globe');
		if (null !== this.block) {
			this.canvas = document.getElementById('scroll-globe');
			this.context = this.canvas.getContext('2d');
			this.imgFolder = this.canvas.getAttribute('data-images');
			this.frameCount = 61;
			this.prevIndex = null;
			this.imgs = {};
			this.imgIndex = 'i001';
			this.baseImg = null;

			if (window.matchMedia('(min-width: 768px)').matches) {
				this.preloadImages();
			}

			this.setGlobeHeightVar();
			this.canvas.width = this.canvas.offsetWidth;
			this.canvas.height = this.canvas.offsetHeight;

			this.baseImg = new Image();
			this.baseImg.src = `${this.imgFolder}001.jpg`;
			this.baseImg.onload = () => {
				this.imgs.i001 = this.baseImg;
				this.fitImageToCanvas();
			};

			window.addEventListener('load', this.handleLoad.bind(this));
			window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
			window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
		}
	}

	handleLoad() {
		this.setGlobeHeightVar();
	}

	handleResize() {
		this.setGlobeHeightVar();
		this.canvas.width = this.canvas.offsetWidth;
		this.canvas.height = this.canvas.offsetHeight;
		this.fitImageToCanvas();
		this.blockOffsetTop = this.block.getBoundingClientRect().top;
	}

	handleScroll() {
		if (window.matchMedia('(min-width: 768px)').matches && !window.reduceAnimations) {
			const scrollTop = window.scrollY - this.block.offsetTop;
			const maxScrollTop = this.block.scrollHeight - window.innerHeight;
			const scrollFraction = scrollTop / maxScrollTop;
			let frameIndex = Math.min(
				this.frameCount - 1,
				Math.floor(scrollFraction * this.frameCount)
			);

			if (frameIndex < 0) {
				frameIndex = 0;
			}

			this.imgIndex = 'i' + (frameIndex + 1).toString().padStart(3, '0');

			if (this.prevIndex !== frameIndex) {
				requestAnimationFrame(() => this.fitImageToCanvas());
				this.prevIndex = frameIndex;
			}
		}
	}

	setGlobeHeightVar() {
		document.documentElement.style.setProperty(
			'--scrollGlobeHeightHalf',
			`${this.canvas.offsetHeight / 2}px`
		);
	}

	getCurrentImg() {
		if ('undefined' === typeof this.imgs[this.imgIndex]) {
			this.baseImg.src = this.getImageUrl(this.imgIndex);
			this.imgs[this.imgIndex] = this.baseImg;
		}

		return this.imgs[this.imgIndex];
	}

	fitImageToCanvas() {
		const img = this.getCurrentImg();
		const ratio = img.width / img.height;
		let newWidth = this.canvas.width;
		let newHeight = newWidth / ratio;
		if (newHeight > this.canvas.height) {
			newHeight = this.canvas.height;
			newWidth = newHeight * ratio;
		}
		const xOffset = newWidth < this.canvas.width ? (this.canvas.width - newWidth) / 2 : 0;
		const yOffset = newHeight < this.canvas.height ? (this.canvas.height - newHeight) / 2 : 0;
		this.context.drawImage(img, xOffset, yOffset, newWidth, newHeight);
	}

	getImageUrl(index) {
		if (index < 0) {
			index = 0;
		}

		return `${this.imgFolder}${(index + 1).toString().padStart(3, '0')}.jpg`;
	}

	preloadImages() {
		for (let i = this.frameCount - 1; i >= 0; i--) {
			const img = new Image();
			img.src = this.getImageUrl(i);

			const fileName = 'i' + (i + 1).toString().padStart(3, '0');
			this.imgs[fileName] = img;
		}
	}
}

new ScrollGlobe();
